import api from "../../../utils/axiosInstance"


const ENDPOINT = "/billing-cycles/"

class BillingCycleService {
  list = () => api.get(ENDPOINT).then((r) => r.data)
  get = (id) => api.get(`${ENDPOINT}${id}/`).then((r) => r.data)
  create = (payload) => api.post(ENDPOINT, payload)
  update = (id, payload) => api.patch(`${ENDPOINT}${id}/`, payload)
  remove = (id) => api.delete(`${ENDPOINT}${id}/`)
}
export default new BillingCycleService()
